import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AriannaComponent } from './arianna.component';

import { TabsModule } from 'beyond-util';

@NgModule({
  declarations: [AriannaComponent],
  entryComponents: [AriannaComponent],
  exports: [AriannaComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
})
export class AriannaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/arianna/arianna.module.ts